import $ from "jquery";
import debug from "bows";

const log = debug("cards");
const $cards = $('.card');
const $featured_resource = $('.featured-resource');

function card_hover() {
	$cards.find('a').hover(function () {
		$(this).closest('.card').addClass('card--hover');
	}, function () {
		$(this).closest('.card').removeClass('card--hover');
	});
}

function featured_resource_hover() {
	$featured_resource.find('a').hover(function () {
		$(this).closest('.featured-resource').addClass('featured-resource--hover');
	}, function () {
		$(this).closest('.featured-resource').removeClass('featured-resource--hover');
	});
}



export function init() {
	if ($cards.length) {
		card_hover();
	}

	if ($featured_resource.length) {
		featured_resource_hover();
	}
}

export default {
	init
};
